
import { NavLink } from "react-router-dom";
import "./Navbar.css";
//import { useEffect, useRef, useState } from "react";
const Navbar = () => {

  return (
    <nav class="navbar">
      <div class="navbar-container">
        <a href="/" class="logo">SHREE BRAINS</a>
        <ul class="nav-links">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/services">Services</NavLink>
          <NavLink to="/contact">Contact</NavLink>
          <li className="dropdown">
            <button className="dropbtn">
              Platforms ▼
            </button>

            <div className="dropdown-content">
              <a
                href="https://crm.shreebrains.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                ECommerce CRM
              </a>

              {/* <a
                href="https://shreebrains.in"
                target="_blank"
                rel="noopener noreferrer"
              > */}
               <a
                href="https://shrishya.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ecommerce
              </a>
            </div>
          </li>

        </ul>

      </div>
    </nav>


  )
};
export default Navbar;